module.exports = __webpack_public_path__ + "img/daka.28fa5707.png";